import styled from 'styled-components';
import { ReactComponent as IconDown } from '../../../Static/icons/arrow_small1.svg';

import { StyledInput } from '../Input/StyledInput';

import S from '../variables';

export const StyledSelect = styled.div`
  position: relative;
  height: 45px;
  cursor: pointer;
  &.opened > input {
    border-radius: 5px 5px 0 0;
  }
  &.disabled {
    cursor: not-allowed;
    pointer-events: none;

    & svg {
      display: none;
    }
  }
  &.form__input > input[disabled] {
    color: ${S.mainBlackText};
  }
  & * {
    user-select: none;
  }
`;

export const StyledSelectOutput = styled(StyledInput)`
  pointer-events: none;
  &.search {
    pointer-events: auto;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }
`;

export const StyledOptionsWrapper = styled.div`
  position: absolute;
  z-index: 4;
  top: 45px;
  height: 0;
  overflow: hidden;
  width: 100%;
  border: solid;
  border-width: 0px;
  border-top: none;
  border-color: transparent;
  transition: height ${S.trFast}, border-color 0s linear 250ms,
    border-width 0s linear 250ms;
  border-radius: 0px 0px 5px 5px;
  background: #fff;
  &.active {
    border-width: 1px;
    border-color: ${S.disabledBorder};
    transition: height ${S.trFast}, border-color 0s linear,
      border-width 0s linear;
  }
`;

export const StyledOptionsList = styled.ul`
  padding: 10px 0;
  width: calc(100% - 10px);
`;

export const StyledOption = styled.li`
  position: relative;
  display: flex;
  align-items: center;
  padding: 0px 0px 0px 32px;
  cursor: pointer;
  height: 27px;
  width: 100%;
  font-weight: 400;
  font-size: 12px;
  line-height: 27px;
  letter-spacing: 0.03em;
  &:hover {
    background: ${S.hoverGreyBg};
    &:after {
      border: 1px solid ${S.mainGreyText};
    }
  }
  &:after {
    content: '';
    position: absolute;
    left: 12px;
    width: 12px;
    height: 12px;
    border-radius: 1px;
    background: #fff;
    border: 1px solid ${S.disabledBorder};
  }
  &.selected:after {
    background: ${S.accentGold};
    border: 1px solid ${S.accentGold};
  }
`;

export const StyledIconDown = styled(IconDown)`
  position: absolute;
  top: 15px;
  right: 17px;
  z-index: 1;
  transform: rotate(-90deg);
  transition: transform ${S.trFast};
  &.active {
    transform: rotate(90deg);
  }
`;

export const StyledScrollBar = styled.div`
  height: calc(100% - 20px);
  position: absolute;
  z-index: 5;
  bottom: 10px;
  right: 5px;
  border-radius: 2px;
  background-color: ${S.disabledBorder};
  width: 8px;
`;

export const StyledScrollBarRunner = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 8px;
  height: 20px;
  background-color: ${S.accentGold};
  border-radius: 2px;
`;
